
import Sdk from "casdoor-js-sdk";
import { base_url } from "./config";

let CasdoorSdk = null;

function getTenantId() {
  const hostnameParts = window.location.hostname.split('.');
  if (hostnameParts.length >= 3 && hostnameParts[0] !== 'www') {
    return hostnameParts[0];
  }
  return null;
}


try {
  const response = await fetch(`${base_url.erp_config}/frontend/casdoor-sdk-config?tenantId=${getTenantId()}`);
  const config = await response?.json();
  sessionStorage.setItem("casdoorConfig", JSON.stringify(config));
  CasdoorSdk = new Sdk(config);
} catch (error) {
  console.error("Failed to initialize Casdoor SDK:", error);
}

export default CasdoorSdk;

export function getSignupUrl() {
  return CasdoorSdk?.getSignupUrl();
}

export function getSigninUrl() {
  return CasdoorSdk?.getSigninUrl();
}

export function getUserProfileUrl(userName, account) {
  return CasdoorSdk?.getUserProfileUrl(userName, account);
}

export function getMyProfileUrl(account) {
  return CasdoorSdk?.getMyProfileUrl(account);
}

export function getMyResourcesUrl(account) {
  return CasdoorSdk?.getMyProfileUrl(account).replace("/account?", "/resources?");
}

export function signin() {
  return CasdoorSdk?.signin(casdoor_config.serverUrl);
}

export function showMessage(type, text) {
  if (type === "") {
    return;
  } else if (type === "success") {
    message.success(text);
  } else if (type === "error") {
    message.error(text);
  }
}

export function goToLink(link) {
  window.location.href = link;
}